<script>
	import ModelCompare from "./ModelCompare.svelte";
	import Slider from "./Slider.svelte";
	import Pixel from "./Pixel.svelte";

	const zeroFill3 = (n) => (n < 10 ? `00${n}` : n < 100 ? `0${n}` : n);
	const zeroFill2 = (n) => (n < 10 ? `0${n}` : n);
	const zeroFill = (n) => (imgCount > 99 ? zeroFill3(n) : zeroFill2(n));

	const imgCount = 90;
	let active = 0;
	let arr = [];

	const aspect = {
		width: 960,
		height: 520,
	};

	for (let i = 0; i < imgCount; i++) {
		arr[i] = `./imgs/frame/black/${zeroFill(i)}.jpeg`;
	}
	let showComparison = false;
	let interaction = false;
	const toggleComparison = () => {
		showComparison = !showComparison;
		interaction = true;
	};
</script>

<main
	width={aspect.width}
	height={aspect.height}
	style="height: {aspect.height}px;"
>
	<div class="logos">
		<img src="./imgs/logo/2021.png" alt="2021" />
		<img src="./imgs/logo/arkana.png" alt="arkana" />
		<img src="./imgs/logo/renault.png" alt="renault" />
	</div>
	<div class="rotator" width={aspect.width} height={aspect.height}>
		{#each arr as img, i}
			<img
				src={img}
				alt={img}
				class:active={(active + Math.round(imgCount * 0.75)) % imgCount === i}
			/>
		{/each}
	</div>
	<Slider bind:active {imgCount} bind:interaction />

	<button class="compareModels button" on:click={toggleComparison}
		>Compare Models</button
	>
	{#if showComparison}
		<ModelCompare on:toggle={toggleComparison} />
	{/if}
	<Pixel tag="impression" />
	{#if interaction}
		<Pixel tag="interaction" />
	{/if}
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		width: 100%;
		max-width: 620px;
		overflow: hidden;
		position: relative;
		box-sizing: border-box;
		display: grid;
		grid-template-rows: 1fr 5fr 1fr 1fr;
		align-items: center;
		justify-items: center;
	}
	@media (max-width: 500px) {
		main {
			grid-template-rows: 1fr 1fr 1fr 1fr;
			align-items: start;
		}
	}
	.logos {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		z-index: 90;
		width: 90%;
	}
	.logos img {
		max-width: 15%;
	}
	@media (max-width: 500px) {
		.logos img {
			max-width: 30%;
		}
	}

	.rotator {
		width: 80%;
		height: auto;
		position: relative;
		margin: 0 auto;
		aspect-ratio: 960 / 540;
	}
	.rotator img {
		width: 100%;
		max-width: 960px;
		height: auto;
		position: absolute;
		top: 0;
		left: 0;
		opacity: 0;
	}

	.rotator img.active {
		opacity: 1;
	}

	.compareModels {
		margin-top: 2rem;
	}
</style>
